import WithProductDateProgressSearch from "./withProductDateProgressSearch.container";

export default WithProductDateProgressSearch;
